import React, { Component } from "react";
import { Route, Switch }    from "react-router-dom";
import Home                 from "./screens/Dashboard";
import Login                from "./screens/Login";
import NotFound             from "./screens/NotFound";
import Signup               from "./screens/Signup";
import AppliedRoute         from "./components/AppliedRoute";
import ExerciseNew          from "./screens/exercise/ExerciseNew";
import ExerciseNewMultiple  from "./screens/exercise/ExerciseNewMultiple";
import ExerciseList         from "./screens/exercise/ExerciseList";
import ExerciseDelete       from "./screens/exercise/ExerciseDelete";
import MessageListAll       from "./screens/message/MessageListAll";
import ProgramNew           from "./screens/program/ProgramNew";
import Program              from "./screens/program/Program";
import ProgramList          from "./screens/program/ProgramList";

import ClientList           from "./screens/client/ClientList";
import ClientNew            from "./screens/client/ClientNew";
import ClientDetail         from "./screens/client/ClientDetail";

//import AssessmentSingleClientList  from "./screens/assessment/AssessmentSingleClientList";
import AssessmentListAll    from "./screens/assessment/AssessmentListAll";
import AssessmentNew        from "./screens/assessment/AssessmentNew";
//import AssessmentDetail     from "./screens/assessment/AssessmentDetail";

import DocumentSingleClientList from "./screens/document/DocumentSingleClientList";
import DocumentClientListAll    from "./screens/document/DocumentClientListAll";
import DocumentNew              from "./screens/document/DocumentNew";
//import DocumentDetail         from "./screens/document/DocumentDetail";

import ReportDashboard      from "./screens/report/ReportDashboard";

import HelpList             from "./screens/help/HelpList";
import HelpDetail           from "./screens/help/HelpDetail";
import HelpAdminList        from "./screens/help/HelpAdminList";
import HelpNew              from "./screens/help/HelpNew";

import ResetPassword        from "./screens/utils/ResetPassword";
import Setting              from "./screens/setting/Setting";
import Zoom                 from "./screens/zoom/Zoom";
import Scheduler            from "./screens/scheduler/Scheduler";

import AuthenticatedRoute   from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
import SideNavBarMenu       from "./components/SideNavBarMenu";


export default ({ childProps, userHasAuthenticated, unReadMessages, resetGlobalIds }) =>
//export default class Routes extends Component {

    /*constructor(props) {
        super(props);
    }

    render() {
        console.log("Step 0. Routes begin");
        var childProps = this.props.childProps;
        var userHasAuthenticated = this.props.userHasAuthenticated*/
        /*const msgProps = {
              resetUnreadMessageIcon: this.resetUnreadMessageIcon
        };*/

        //return (
                  <Switch>
                    <UnauthenticatedRoute path="/"  exact component={Login}  props={childProps} />
                    <UnauthenticatedRoute path="/login"  exact component={Login}  props={childProps} />
                    <UnauthenticatedRoute path="/signup" exact component={Signup} props={childProps} />
                    <UnauthenticatedRoute path="/reset"  exact component={ResetPassword}   props={childProps}/>
                    <Route render={({ location, history }) => (
                         <React.Fragment>
                              <main>
                                    { /******  LOADS LOGIN PAGE  ******
                                    <AuthenticatedRoute path=""  exact component={Login}  props={childProps} />*/ }

                                    <SideNavBarMenu location             = {location}
                                                    history              = {history}
                                                    props                = {childProps}
                                                    unReadMessages       = {unReadMessages}
                                                    userHasAuthenticated = {userHasAuthenticated}
                                                    resetGlobalIds       = {resetGlobalIds}
                                                />
                                    { /*<AppliedRoute       path="/index" exact component={Home} props={childProps} />*/}
                                    <AuthenticatedRoute path="/index" exact component={Home} props={childProps} />
                                    <AuthenticatedRoute path="/programs/list"                                            exact component={ProgramList}    props={childProps} />
                                    <AuthenticatedRoute path="/programs/detail/:id/:is_template/:client_name/:client_id" exact component={Program}        props={childProps} />
                                    <AuthenticatedRoute path="/programs/new/:client_id/:client_name"                     exact component={ProgramNew}     props={childProps} />
                                    <AuthenticatedRoute path="/programs/list/:client_id/:search_term/:client_name"       exact component={ProgramList}    props={childProps} />

                                    <AuthenticatedRoute path="/message/listAll"                                          exact component={MessageListAll} props={childProps} /*msgProps={msgProps}*/  />

                                    <AuthenticatedRoute path="/assessment/listAllAssessments/:client_id/:search_term"    exact component={AssessmentListAll}        props={childProps} />
                                    <AuthenticatedRoute path="/assessment/listAll/:client_id/:search_term"               exact component={AssessmentListAll}        props={childProps} />
                                    <AuthenticatedRoute path="/assessment/new/:client_id/&/:assessment_type"             exact component={AssessmentNew}         props={childProps} />
                                    <AuthenticatedRoute path="/assessment/edit/:client_id/:document_id/:assessment_type" exact component={AssessmentNew}         props={childProps} />
                                    { /*}<AuthenticatedRoute path="/assessment/detail/:id"                      exact component={AssessmentDetail}      props={childProps} />*/ }

                                    <AuthenticatedRoute path="/client/listAll/:search_term"                            exact component={ClientList}          props={childProps} />
                                    <AuthenticatedRoute path="/client/new"                                             exact component={ClientNew}           props={childProps} />
                                    <AuthenticatedRoute path="/client/edit/:id"                                        exact component={ClientNew}           props={childProps} />
                                    <AuthenticatedRoute path="/client/detail/:id"                                      exact component={ClientDetail}        props={childProps} />
                                    <AuthenticatedRoute path="/client/list/:client_id/:search_term/:client_name"       exact component={ProgramList}   props={childProps} />
                                    <AuthenticatedRoute path="/client/newProgram/:client_id/:client_name"              exact component={ProgramNew}    props={childProps} />
                                    <AuthenticatedRoute path="/client/detail/:id/:is_template/:client_name/:client_id" exact component={Program}       props={childProps} />

                                    <AuthenticatedRoute path="/document/listAllDocuments/:client_id/:search_term"    exact component={DocumentClientListAll}        props={childProps} />
                                    <AuthenticatedRoute path="/document/listAll/:client_id/:search_term" exact component={DocumentSingleClientList}        props={childProps} />
                                    <AuthenticatedRoute path="/document/new/:client_id/&"                exact component={DocumentNew}         props={childProps} />
                                    <AuthenticatedRoute path="/document/edit/:client_id/:document_id"    exact component={DocumentNew}         props={childProps} />
                                    { /*}<AuthenticatedRoute path="/document/detail/:id"                      exact component={DocumentDetail}      props={childProps} /> */ }

                                    <AuthenticatedRoute path="/exercise/new"                    exact component={ExerciseNew}         props={childProps} />
                                    <AuthenticatedRoute path="/exercise/details/:id"            exact component={ExerciseNew}         props={childProps} />
                                    <AuthenticatedRoute path="/exercise/delete/:exercise_id"    exact component={ExerciseDelete}      props={childProps} />
                                    <AuthenticatedRoute path="/exercise/listAll/:search_term"   exact component={ExerciseList}        props={childProps} />
                                    <AuthenticatedRoute path="/exercise/ExerciseNewMultiple"    exact component={ExerciseNewMultiple} props={childProps} />

                                    <AuthenticatedRoute path="/report/reportDashboard"          exact component={ReportDashboard}     props={childProps} />
                                    <AuthenticatedRoute path="/scheduler"                       exact component={Scheduler}           props={childProps} />

                                    <AuthenticatedRoute path="/help"                            exact component={HelpList}            props={childProps} />
                                    <AuthenticatedRoute path="/help/detail/:help_id"            exact component={HelpDetail}          props={childProps} />
                                    <AuthenticatedRoute path="/help/admin/:search_term"         exact component={HelpAdminList}       props={childProps} />
                                    <AuthenticatedRoute path="/help/new/:help_id"               exact component={HelpNew}             props={childProps} />
                                    <AuthenticatedRoute path="/zoom"                            exact component={Zoom}                props={childProps} />

                                    <AuthenticatedRoute path="/setting"                         exact component={Setting}                props={childProps} />
                                 </main>
                         </React.Fragment>
                     )}
                     />
                    <Route component={NotFound} />
                  </Switch>
          /*)
     }
}
*/



// WEBPACK FOOTER //
// ./src/Routes.js